import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { ArrowRight, Calendar, Compass, Mail, Phone, MapPin } from "lucide-react";
// import footerIcon from 'src/Assets/Frame 4319.png';
import footerIcon from '../Assets/footer.png';


interface FooterProps {
  onPageChange?: (page: string) => void;
}

export function Footer({ onPageChange }: FooterProps = {}) {
  const handleNavigation = (page: string) => {
    if (onPageChange) {
      onPageChange(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* CTA Section */}
        <div className="py-16 lg:py-24">
          <Card className="bg-primary-foreground/10 border-primary-foreground/20">
            <CardContent className="p-8 text-center lg:p-12">
              <h2 className="mb-4 text-3xl lg:text-4xl text-white">Ready to Transform Your Procurement?</h2>
              <p className="mb-8 text-lg text-primary-foreground/80">
                Join hundreds of retail enterprises already using NexProcureAI to streamline their operations.
              </p>
              <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
                <Button size="lg" variant="secondary" className="group">
                  <Calendar className="mr-2 h-4 w-4" />
                  Book a Live Demo
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Button>
                <Button size="lg" variant="outline" className="border-primary-foreground/30 text-black hover:bg-primary-foreground/10 hover:text-black">
                  <Compass className="mr-2 h-4 w-4" />
                  Explore Our Solutions
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Footer Links */}
        <div className="border-t border-primary-foreground/20 py-12">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {/* About Us Section */}
            <div>
              <h3 className="mb-4 text-lg">About Us</h3>
              <ul className="space-y-2 text-sm text-primary-foreground/80">
                <li>
                  <button 
                    onClick={() => handleNavigation('story')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    Our Story
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('mission')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    Mission
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('vision')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    Vision
                  </button>
                </li>
              </ul>
            </div>

            {/* Solutions Section */}
            <div>
              <h3 className="mb-4 text-lg">Solutions</h3>
              <ul className="space-y-2 text-sm text-primary-foreground/80">
                <li>
                  <button 
                    onClick={() => handleNavigation('procpay')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    ProcPay
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('plm')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    ProLiMa
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('nexai')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    NexAI
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('demand-forecasting')} 
                    className="hover:text-primary-foreground transition-colors text-left"
                  >
                    Demand Forecasting
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div>
              <h3 className="mb-4 text-lg">Contact</h3>
              <ul className="space-y-3 text-sm text-primary-foreground/80">
                <li className="flex items-center gap-2">
                  <Mail className="h-4 w-4 flex-shrink-0" />
                  <a href="mailto:kumarjit.mukherjee@nexprocureai.com" className="hover:text-primary-foreground transition-colors">
                    kumarjit.mukherjee@nexprocureai.com
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <Phone className="h-4 w-4 flex-shrink-0" />
                  <a href="tel:+919830846904" className="hover:text-primary-foreground transition-colors">
                    +91 98308 46904
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin className="h-4 w-4 flex-shrink-0 mt-0.5" />
                  <span className="leading-relaxed">
                    MODULE NO: 3, Gokul Baral Street,<br />
                    2nd floor, Kolkata - 700012
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-primary-foreground/20 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-primary-foreground/60">
            <div className="flex items-center gap-2">
              <img 
                src={footerIcon} 
                alt="NexProcureAI Icon"
                className="h-5 w-5"
              />
              <span>&copy; 2025 NexProcureAI. All rights reserved.</span>
            </div>
            <button 
              onClick={() => handleNavigation('contact')} 
              className="hover:text-primary-foreground transition-colors"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}